<template>
    <div>
        <select
            class="form-select py-0 max-w-full border-primary"
            :value="value"
            @input="$emit('input', $event.target.value)"
            :disabled="disabled"
        >
            <option disabled :value="null"> </option>
            <option v-for="s in siteList" :key="s.id" :value="s.id">
                {{ s.cmpySiteName }}
            </option>
        </select>
        <contentNewLine
            v-if="showDlvryCmpySiteAddr"
            class="mt-2 text-base"
            :value="cmpySiteAddr"
        />
    </div>
</template>

<script>
import contentNewLine from './contentNewLine';

export default {
    components: {
        contentNewLine
    },
    props: {
        value: { type: Number, required: true },
        showDlvryCmpySiteAddr: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false }
    },
    computed: {
        siteList() {
            return (this.$store.state.companySiteList || []).map(s => ({
                cmpySiteName: s.cmpySiteName,
                cmpySiteAddr: s.cmpySiteAddr,
                id: s.id
            }));
        },
        cmpySiteAddr() {
            return this.siteList.find(s => s.id === this.value)?.cmpySiteAddr;
        }
    }
};
</script>
